/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import {
    REQUEST_GROUPS, FETCH_GROUPS_DASHBOARD_SUCCESS, FETCH_GROUPS_DASHBOARD_FAILURE,
    REQUEST_GROUP_PROFILES, FETCH_GROUP_PROFILES_DASHBOARD_SUCCESS, FETCH_GROUP_PROFILES_DASHBOARD_FAILURE,
    REQUEST_GROUP_DEVICES, FETCH_GROUP_DEVICES_DASHBOARD_SUCCESS, FETCH_GROUP_DEVICES_DASHBOARD_FAILURE,
    REQUEST_DEVICE_BY_DEVICEID, FETCH_DEVICE_BY_DEVICEID_DASHBOARD_SUCCESS, FETCH_DEVICE_BY_DEVICEID_DASHBOARD_FAILURE
} from './actionTypes'

export function fetchGroups(options, groupId) {
    return {
        type: REQUEST_GROUPS,
        options: options,
        groupId: groupId
    }
}
export function fetchGroupsSuccess(json) {
    return {
        type: FETCH_GROUPS_DASHBOARD_SUCCESS,
        groupsDetails: json
    }
}

export function fetchGroupsFailure(error) {
    return {
        type: FETCH_GROUPS_DASHBOARD_FAILURE,
        errorMessage: error.message,
        options: error.options
    }
}

export function fetchGroupProfiles(options, groupId) {
    return {
        type: REQUEST_GROUP_PROFILES,
        options: options,
        groupId: groupId
    }
}
export function fetchGroupProfilesFailure(error) {
    return {
        type: FETCH_GROUP_PROFILES_DASHBOARD_FAILURE,
        errorMessage: error.message,
        options: error.options
    }
}

export function fetchGroupProfilesSuccess(json) {
    return {
        type: FETCH_GROUP_PROFILES_DASHBOARD_SUCCESS,
        profilesDetails: json
    }
}

export function fetchGroupDevices(options, groupId) {
    return {
        type: REQUEST_GROUP_DEVICES,
        options: options,
        groupId: groupId
    }
}
export function fetchGroupDevicesFailure(error) {
    return {
        type: FETCH_GROUP_DEVICES_DASHBOARD_FAILURE,
        errorMessage: error.message,
        options: error.options
    }
}

export function fetchGroupDevicesSuccess(json) {
    return {
        type: FETCH_GROUP_DEVICES_DASHBOARD_SUCCESS,
        devicesDetails: json
    }
}


export function fetchDeviceByDeviceId(deviceId, profileId) {
    return {
        type: REQUEST_DEVICE_BY_DEVICEID,
        deviceId: deviceId,
        profileId: profileId
    }
}
export function fetchDeviceByDeviceIdSuccess(json) {
    return {
        type: FETCH_DEVICE_BY_DEVICEID_DASHBOARD_SUCCESS,
        deviceDetails: json
    }
}

export function fetchDeviceByDeviceIdFailure(error) {
    return {
        type: FETCH_DEVICE_BY_DEVICEID_DASHBOARD_FAILURE,
        errorMessage: error.message
    }

}
